const toolbox = [
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_LED}',
    categorystyle: 'led_category',
    cssConfig: {
      icon: 'customIcon categoryIfbalance categoryIfblock'
    },
    contents: [
      {
        kind: 'block',
        type: 'common_color'
      },
      {
        kind: 'block',
        type: 'machine_ifzero_led'
      },
      {
        kind: 'block',
        blockxml: `
            <block type="machine_ifline_led">
              <value name="COLOR">
                <block type="common_color">
                  <field name="COLOR">#ff6600</field>
                </block>
              </value>
              <value name="LED">
                <block type="math_number">
                  <field name="NUM">0</field>
                </block>
              </value>
            </block>`
      }
    ]
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_SENSOR}',
    categorystyle: 'sensor_category',
    cssConfig: {
      icon: 'customIcon categoryIfbalance categoryIfblock'
    },
    contents: [
      {
        kind: 'block',
        type: 'machine_ifzero_bmp_get'
      },
      {
        kind: 'block',
        type: 'machine_ifzero_mpu_get'
      },
      {
        kind: 'block',
        type: 'machine_ifzero_battery_get'
      }
    ]
  }
]

export default toolbox
